import {
  getAnchorPlugin,
  waitUntil,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
/* START OF COMPILED CODE */

import UIBlocker from "../prefabs/GeneralUI/UIBlocker";
import DefaultButton from "../prefabs/GeneralUI/Buttons/DefaultButton";
import DefaultDenyButton from "../prefabs/GeneralUI/Buttons/DefaultDenyButton";
import DefaultConfirmButton_m from "../prefabs/DefaultConfirmButton_m";
import LoadingContainer from "../prefabs/GeneralUI/LoadingContainer";
/* START-USER-IMPORTS */
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { WalkthroughController } from '@/game/GameComponents/PhaserGame/Utils/WalkthroughController';
/* END-USER-IMPORTS */

export default class WalkthroughPanel extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// uIBlocker
		const uIBlocker = new UIBlocker(scene, 0, 0);
		uIBlocker.visible = true;
		this.add(uIBlocker);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// greenleaf_m
		const greenleaf_m = scene.add.image(104, 344, "npc_mentor_e_portrait");
		greenleaf_m.scaleX = -0.4;
		greenleaf_m.scaleY = 0.4;
		mobileView.add(greenleaf_m);

		// overlayContainer_m
		const overlayContainer_m = scene.add.container(0, 0);
		mobileView.add(overlayContainer_m);

		// overlay_intro_m
		const overlay_intro_m = scene.add.container(0, 0);
		overlayContainer_m.add(overlay_intro_m);

		// rightOverlays_m
		const rightOverlays_m = scene.add.container(668, 0);
		overlayContainer_m.add(rightOverlays_m);

		// overlay_1_m
		const overlay_1_m = scene.add.container(-4, 4);
		rightOverlays_m.add(overlay_1_m);

		// dailiesOverlay_m
		const dailiesOverlay_m = scene.add.image(-280, 28, "dailies-reveal_32");
		dailiesOverlay_m.scaleX = 2;
		dailiesOverlay_m.scaleY = 2;
		dailiesOverlay_m.setOrigin(0.5, 0);
		overlay_1_m.add(dailiesOverlay_m);

		// guidanceArrow_m
		const guidanceArrow_m = scene.add.image(-280, 128, "GuidanceArrow-Small");
		guidanceArrow_m.scaleX = 4;
		guidanceArrow_m.scaleY = 4;
		overlay_1_m.add(guidanceArrow_m);

		// labelContainer
		const labelContainer = scene.add.container(-280, 156);
		overlay_1_m.add(labelContainer);

		// textBacking
		const textBacking = scene.add.nineslice(0, 2, "fadeOut2", undefined, 50, 0, 3, 3, 0, 0);
		textBacking.scaleX = 4;
		textBacking.scaleY = 32;
		textBacking.setOrigin(0.5, 0);
		textBacking.alpha = 0.5;
		textBacking.tint = 3023407;
		labelContainer.add(textBacking);

		// dailiesLabel_m
		const dailiesLabel_m = scene.add.bitmapText(0, 0, "Aronui", "Daily Tasks");
		dailiesLabel_m.setOrigin(0.5, 0);
		dailiesLabel_m.tintTopLeft = 15130076;
		dailiesLabel_m.tintTopRight = 15130076;
		dailiesLabel_m.tintBottomLeft = 15130076;
		dailiesLabel_m.tintBottomRight = 15130076;
		dailiesLabel_m.text = "Daily Tasks";
		dailiesLabel_m.fontSize = -28;
		labelContainer.add(dailiesLabel_m);

		// overlay_2_m
		const overlay_2_m = scene.add.container(-4, 4);
		rightOverlays_m.add(overlay_2_m);

		// dailiesOverlay_1_m
		const dailiesOverlay_1_m = scene.add.image(-344, 28, "mastery-reveal_32");
		dailiesOverlay_1_m.scaleX = 2;
		dailiesOverlay_1_m.scaleY = 2;
		dailiesOverlay_1_m.setOrigin(0.5, 0);
		overlay_2_m.add(dailiesOverlay_1_m);

		// guidanceArrow_1_m
		const guidanceArrow_1_m = scene.add.image(-344, 128, "GuidanceArrow-Small");
		guidanceArrow_1_m.scaleX = 4;
		guidanceArrow_1_m.scaleY = 4;
		overlay_2_m.add(guidanceArrow_1_m);

		// labelContainer_1
		const labelContainer_1 = scene.add.container(-344, 156);
		overlay_2_m.add(labelContainer_1);

		// textBacking_1
		const textBacking_1 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 32, 0, 3, 3, 0, 0);
		textBacking_1.scaleX = 4;
		textBacking_1.scaleY = 32;
		textBacking_1.setOrigin(0.5, 0);
		textBacking_1.alpha = 0.5;
		textBacking_1.tint = 3023407;
		labelContainer_1.add(textBacking_1);

		// dailiesLabel_m_1
		const dailiesLabel_m_1 = scene.add.bitmapText(0, 0, "Aronui", "Codex");
		dailiesLabel_m_1.setOrigin(0.5, 0);
		dailiesLabel_m_1.tintTopLeft = 15130076;
		dailiesLabel_m_1.tintTopRight = 15130076;
		dailiesLabel_m_1.tintBottomLeft = 15130076;
		dailiesLabel_m_1.tintBottomRight = 15130076;
		dailiesLabel_m_1.text = "Codex";
		dailiesLabel_m_1.fontSize = -28;
		labelContainer_1.add(dailiesLabel_m_1);

		// overlay_3_m
		const overlay_3_m = scene.add.container(-4, 4);
		rightOverlays_m.add(overlay_3_m);

		// dailiesOverlay_2_m
		const dailiesOverlay_2_m = scene.add.image(-416, 28, "shop-reveal_32");
		dailiesOverlay_2_m.scaleX = 2;
		dailiesOverlay_2_m.scaleY = 2;
		dailiesOverlay_2_m.setOrigin(0.5, 0);
		overlay_3_m.add(dailiesOverlay_2_m);

		// guidanceArrow_2_m
		const guidanceArrow_2_m = scene.add.image(-416, 128, "GuidanceArrow-Small");
		guidanceArrow_2_m.scaleX = 4;
		guidanceArrow_2_m.scaleY = 4;
		overlay_3_m.add(guidanceArrow_2_m);

		// labelContainer_2
		const labelContainer_2 = scene.add.container(-416, 156);
		overlay_3_m.add(labelContainer_2);

		// textBacking_2
		const textBacking_2 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 28, 0, 3, 3, 0, 0);
		textBacking_2.scaleX = 4;
		textBacking_2.scaleY = 32;
		textBacking_2.setOrigin(0.5, 0);
		textBacking_2.alpha = 0.5;
		textBacking_2.tint = 3023407;
		labelContainer_2.add(textBacking_2);

		// dailiesLabel_m_2
		const dailiesLabel_m_2 = scene.add.bitmapText(0, 0, "Aronui", "Shop");
		dailiesLabel_m_2.setOrigin(0.5, 0);
		dailiesLabel_m_2.tintTopLeft = 15130076;
		dailiesLabel_m_2.tintTopRight = 15130076;
		dailiesLabel_m_2.tintBottomLeft = 15130076;
		dailiesLabel_m_2.tintBottomRight = 15130076;
		dailiesLabel_m_2.text = "Shop";
		dailiesLabel_m_2.fontSize = -28;
		labelContainer_2.add(dailiesLabel_m_2);

		// overlay_4_m
		const overlay_4_m = scene.add.container(-4, 4);
		rightOverlays_m.add(overlay_4_m);

		// dailiesOverlay_3_m
		const dailiesOverlay_3_m = scene.add.image(-488, 28, "inventory-reveal_32");
		dailiesOverlay_3_m.scaleX = 2;
		dailiesOverlay_3_m.scaleY = 2;
		dailiesOverlay_3_m.setOrigin(0.5, 0);
		overlay_4_m.add(dailiesOverlay_3_m);

		// guidanceArrow_3_m
		const guidanceArrow_3_m = scene.add.image(-488, 128, "GuidanceArrow-Small");
		guidanceArrow_3_m.scaleX = 4;
		guidanceArrow_3_m.scaleY = 4;
		overlay_4_m.add(guidanceArrow_3_m);

		// labelContainer_3
		const labelContainer_3 = scene.add.container(-488, 156);
		overlay_4_m.add(labelContainer_3);

		// textBacking_3
		const textBacking_3 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 40, 0, 3, 3, 0, 0);
		textBacking_3.scaleX = 4;
		textBacking_3.scaleY = 32;
		textBacking_3.setOrigin(0.5, 0);
		textBacking_3.alpha = 0.5;
		textBacking_3.tint = 3023407;
		labelContainer_3.add(textBacking_3);

		// dailiesLabel_m_3
		const dailiesLabel_m_3 = scene.add.bitmapText(0, 0, "Aronui", "Backpack");
		dailiesLabel_m_3.setOrigin(0.5, 0);
		dailiesLabel_m_3.tintTopLeft = 15130076;
		dailiesLabel_m_3.tintTopRight = 15130076;
		dailiesLabel_m_3.tintBottomLeft = 15130076;
		dailiesLabel_m_3.tintBottomRight = 15130076;
		dailiesLabel_m_3.text = "Backpack";
		dailiesLabel_m_3.fontSize = -28;
		labelContainer_3.add(dailiesLabel_m_3);

		// overlay_5_m
		const overlay_5_m = scene.add.container(-4, 4);
		rightOverlays_m.add(overlay_5_m);

		// dailiesOverlay_4_m
		const dailiesOverlay_4_m = scene.add.image(-560, 28, "settings-reveal");
		dailiesOverlay_4_m.scaleX = 4;
		dailiesOverlay_4_m.scaleY = 4;
		dailiesOverlay_4_m.setOrigin(0.5, 0);
		overlay_5_m.add(dailiesOverlay_4_m);

		// guidanceArrow_4_m
		const guidanceArrow_4_m = scene.add.image(-560, 128, "GuidanceArrow-Small");
		guidanceArrow_4_m.scaleX = 4;
		guidanceArrow_4_m.scaleY = 4;
		overlay_5_m.add(guidanceArrow_4_m);

		// labelContainer_4
		const labelContainer_4 = scene.add.container(-560, 156);
		overlay_5_m.add(labelContainer_4);

		// textBacking_4
		const textBacking_4 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 40, 0, 3, 3, 0, 0);
		textBacking_4.scaleX = 4;
		textBacking_4.scaleY = 32;
		textBacking_4.setOrigin(0.5, 0);
		textBacking_4.alpha = 0.5;
		textBacking_4.tint = 3023407;
		labelContainer_4.add(textBacking_4);

		// dailiesLabel_m_4
		const dailiesLabel_m_4 = scene.add.bitmapText(0, 0, "Aronui", "Settings");
		dailiesLabel_m_4.setOrigin(0.5, 0);
		dailiesLabel_m_4.tintTopLeft = 15130076;
		dailiesLabel_m_4.tintTopRight = 15130076;
		dailiesLabel_m_4.tintBottomLeft = 15130076;
		dailiesLabel_m_4.tintBottomRight = 15130076;
		dailiesLabel_m_4.text = "Settings";
		dailiesLabel_m_4.fontSize = -28;
		labelContainer_4.add(dailiesLabel_m_4);

		// overlay_6_m
		const overlay_6_m = scene.add.container(0, 0);
		rightOverlays_m.add(overlay_6_m);

		// dailiesOverlay_5_m
		const dailiesOverlay_5_m = scene.add.image(-636, 32, "find-minigames-reveal_32");
		dailiesOverlay_5_m.scaleX = 2;
		dailiesOverlay_5_m.scaleY = 2;
		dailiesOverlay_5_m.setOrigin(0.5, 0);
		overlay_6_m.add(dailiesOverlay_5_m);

		// guidanceArrow_5_m
		const guidanceArrow_5_m = scene.add.image(-636, 132, "GuidanceArrow-Small");
		guidanceArrow_5_m.scaleX = 4;
		guidanceArrow_5_m.scaleY = 4;
		overlay_6_m.add(guidanceArrow_5_m);

		// labelContainer_5
		const labelContainer_5 = scene.add.container(-604, 160);
		overlay_6_m.add(labelContainer_5);

		// textBacking_5
		const textBacking_5 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 64, 0, 3, 3, 0, 0);
		textBacking_5.scaleX = 4;
		textBacking_5.scaleY = 32;
		textBacking_5.setOrigin(0.5, 0);
		textBacking_5.alpha = 0.5;
		textBacking_5.tint = 3023407;
		labelContainer_5.add(textBacking_5);

		// dailiesLabel_m_5
		const dailiesLabel_m_5 = scene.add.bitmapText(0, 0, "Aronui", "Find Minigames");
		dailiesLabel_m_5.setOrigin(0.5, 0);
		dailiesLabel_m_5.tintTopLeft = 15130076;
		dailiesLabel_m_5.tintTopRight = 15130076;
		dailiesLabel_m_5.tintBottomLeft = 15130076;
		dailiesLabel_m_5.tintBottomRight = 15130076;
		dailiesLabel_m_5.text = "Find Minigames";
		dailiesLabel_m_5.fontSize = -28;
		labelContainer_5.add(dailiesLabel_m_5);

		// leftOverlays_m
		const leftOverlays_m = scene.add.container(0, 0);
		overlayContainer_m.add(leftOverlays_m);

		// bottomOverlays_m
		const bottomOverlays_m = scene.add.container(334, 380);
		overlayContainer_m.add(bottomOverlays_m);

		// overlay_7_m
		const overlay_7_m = scene.add.container(0, 0);
		bottomOverlays_m.add(overlay_7_m);

		// backing_m
		const backing_m = scene.add.nineslice(0, -152, "Hud1", undefined, 144, 64, 8, 8, 8, 8);
		backing_m.scaleX = 4;
		backing_m.scaleY = 4;
		overlay_7_m.add(backing_m);

		// acceptButton_m
		const acceptButton_m = new DefaultButton(scene, -104, -72);
		acceptButton_m.scaleX = 1;
		acceptButton_m.scaleY = 1;
		overlay_7_m.add(acceptButton_m);

		// duelButton_m
		const duelButton_m = scene.add.image(232, -224, "duel2");
		duelButton_m.scaleX = 4;
		duelButton_m.scaleY = 4;
		overlay_7_m.add(duelButton_m);

		// dialogueText_m
		const dialogueText_m = scene.add.bitmapText(-200, -176, "Aronui", "Let's match letters to their sounds in Mystic Match!");
		dialogueText_m.tintTopLeft = 5387071;
		dialogueText_m.tintTopRight = 5387071;
		dialogueText_m.tintBottomLeft = 5387071;
		dialogueText_m.tintBottomRight = 5387071;
		dialogueText_m.text = "Let's match letters to their sounds in Mystic Match!";
		dialogueText_m.fontSize = -24;
		dialogueText_m.maxWidth = 425;
		overlay_7_m.add(dialogueText_m);

		// cancelButton_m
		const cancelButton_m = new DefaultDenyButton(scene, 112, -72);
		cancelButton_m.scaleX = 1;
		cancelButton_m.scaleY = 1;
		overlay_7_m.add(cancelButton_m);

		// tint_m
		const tint_m = scene.add.image(-288, -280, "1x1sprite");
		tint_m.scaleX = 576;
		tint_m.scaleY = 256;
		tint_m.setOrigin(0, 0);
		tint_m.alpha = 0.3;
		tint_m.alphaTopLeft = 0.3;
		tint_m.alphaTopRight = 0.3;
		tint_m.alphaBottomLeft = 0.3;
		tint_m.alphaBottomRight = 0.3;
		tint_m.tintTopLeft = 0;
		tint_m.tintTopRight = 0;
		tint_m.tintBottomLeft = 0;
		tint_m.tintBottomRight = 0;
		overlay_7_m.add(tint_m);

		// dailiesOverlay_6_m
		const dailiesOverlay_6_m = scene.add.image(232, -256, "duel-reveal");
		dailiesOverlay_6_m.scaleX = 4;
		dailiesOverlay_6_m.scaleY = 4;
		dailiesOverlay_6_m.setOrigin(0.5, 0);
		overlay_7_m.add(dailiesOverlay_6_m);

		// guidanceArrow_6_m
		const guidanceArrow_6_m = scene.add.image(232, -296, "GuidanceArrow-Small");
		guidanceArrow_6_m.scaleX = 4;
		guidanceArrow_6_m.scaleY = 4;
		guidanceArrow_6_m.flipY = true;
		overlay_7_m.add(guidanceArrow_6_m);

		// labelContainer_6
		const labelContainer_6 = scene.add.container(234, -368);
		overlay_7_m.add(labelContainer_6);

		// textBacking_6
		const textBacking_6 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 50, 0, 3, 3, 0, 0);
		textBacking_6.scaleX = 4;
		textBacking_6.scaleY = 32;
		textBacking_6.setOrigin(0.5, 0);
		textBacking_6.alpha = 0.5;
		textBacking_6.tint = 3023407;
		labelContainer_6.add(textBacking_6);

		// dailiesLabel_m_6
		const dailiesLabel_m_6 = scene.add.bitmapText(0, 0, "Aronui", "Start Duel");
		dailiesLabel_m_6.setOrigin(0.5, 0);
		dailiesLabel_m_6.tintTopLeft = 15130076;
		dailiesLabel_m_6.tintTopRight = 15130076;
		dailiesLabel_m_6.tintBottomLeft = 15130076;
		dailiesLabel_m_6.tintBottomRight = 15130076;
		dailiesLabel_m_6.text = "Start Duel";
		dailiesLabel_m_6.fontSize = -28;
		labelContainer_6.add(dailiesLabel_m_6);

		// interactiveOverlay_m
		const interactiveOverlay_m = scene.add.image(0, 0, "1x1sprite");
		interactiveOverlay_m.setInteractive(new Phaser.Geom.Rectangle(0, 0, 1, 1), Phaser.Geom.Rectangle.Contains);
		interactiveOverlay_m.scaleX = 1024;
		interactiveOverlay_m.scaleY = 768;
		interactiveOverlay_m.setOrigin(0, 0);
		interactiveOverlay_m.alpha = 0.0001;
		interactiveOverlay_m.alphaTopLeft = 0.0001;
		interactiveOverlay_m.alphaTopRight = 0.0001;
		interactiveOverlay_m.alphaBottomLeft = 0.0001;
		interactiveOverlay_m.alphaBottomRight = 0.0001;
		mobileView.add(interactiveOverlay_m);

		// continueButtonContainer_m
		const continueButtonContainer_m = scene.add.container(668, 376);
		mobileView.add(continueButtonContainer_m);

		// continueButton_m
		const continueButton_m = new DefaultConfirmButton_m(scene, -120, -48);
		continueButtonContainer_m.add(continueButton_m);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// greenleaf
		const greenleaf = scene.add.image(870, 538, "npc_mentor_e_portrait");
		greenleaf.scaleX = 0.4;
		greenleaf.scaleY = 0.4;
		desktopView.add(greenleaf);

		// overlayContainer
		const overlayContainer = scene.add.container(0, 0);
		desktopView.add(overlayContainer);

		// overlay_intro
		const overlay_intro = scene.add.container(0, 0);
		overlayContainer.add(overlay_intro);

		// rightOverlays
		const rightOverlays = scene.add.container(1024, 0);
		overlayContainer.add(rightOverlays);

		// overlay_1
		const overlay_1 = scene.add.container(-4, 4);
		overlay_1.visible = false;
		rightOverlays.add(overlay_1);

		// dailiesOverlay
		const dailiesOverlay = scene.add.image(-212, 28, "dailies-reveal_32");
		dailiesOverlay.scaleX = 2;
		dailiesOverlay.scaleY = 2;
		dailiesOverlay.setOrigin(0.5, 0);
		overlay_1.add(dailiesOverlay);

		// guidanceArrow
		const guidanceArrow = scene.add.image(-212, 128, "GuidanceArrow-Small");
		guidanceArrow.scaleX = 4;
		guidanceArrow.scaleY = 4;
		overlay_1.add(guidanceArrow);

		// labelContainer_7
		const labelContainer_7 = scene.add.container(-212, 156);
		overlay_1.add(labelContainer_7);

		// textBacking_7
		const textBacking_7 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 50, 0, 3, 3, 0, 0);
		textBacking_7.scaleX = 4;
		textBacking_7.scaleY = 32;
		textBacking_7.setOrigin(0.5, 0);
		textBacking_7.alpha = 0.5;
		textBacking_7.tint = 3023407;
		labelContainer_7.add(textBacking_7);

		// dailiesLabel_m_7
		const dailiesLabel_m_7 = scene.add.bitmapText(0, 0, "Aronui", "Daily Tasks");
		dailiesLabel_m_7.setOrigin(0.5, 0);
		dailiesLabel_m_7.tintTopLeft = 15130076;
		dailiesLabel_m_7.tintTopRight = 15130076;
		dailiesLabel_m_7.tintBottomLeft = 15130076;
		dailiesLabel_m_7.tintBottomRight = 15130076;
		dailiesLabel_m_7.text = "Daily Tasks";
		dailiesLabel_m_7.fontSize = -28;
		labelContainer_7.add(dailiesLabel_m_7);

		// overlay_2
		const overlay_2 = scene.add.container(-4, 4);
		overlay_2.visible = false;
		rightOverlays.add(overlay_2);

		// dailiesOverlay_1
		const dailiesOverlay_1 = scene.add.image(-276, 28, "mastery-reveal_32");
		dailiesOverlay_1.scaleX = 2;
		dailiesOverlay_1.scaleY = 2;
		dailiesOverlay_1.setOrigin(0.5, 0);
		overlay_2.add(dailiesOverlay_1);

		// guidanceArrow_1
		const guidanceArrow_1 = scene.add.image(-280, 128, "GuidanceArrow-Small");
		guidanceArrow_1.scaleX = 4;
		guidanceArrow_1.scaleY = 4;
		overlay_2.add(guidanceArrow_1);

		// labelContainer_8
		const labelContainer_8 = scene.add.container(-276, 156);
		overlay_2.add(labelContainer_8);

		// textBacking_8
		const textBacking_8 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 32, 0, 3, 3, 0, 0);
		textBacking_8.scaleX = 4;
		textBacking_8.scaleY = 32;
		textBacking_8.setOrigin(0.5, 0);
		textBacking_8.alpha = 0.5;
		textBacking_8.tint = 3023407;
		labelContainer_8.add(textBacking_8);

		// dailiesLabel_m_8
		const dailiesLabel_m_8 = scene.add.bitmapText(0, 0, "Aronui", "Codex");
		dailiesLabel_m_8.setOrigin(0.5, 0);
		dailiesLabel_m_8.tintTopLeft = 15130076;
		dailiesLabel_m_8.tintTopRight = 15130076;
		dailiesLabel_m_8.tintBottomLeft = 15130076;
		dailiesLabel_m_8.tintBottomRight = 15130076;
		dailiesLabel_m_8.text = "Codex";
		dailiesLabel_m_8.fontSize = -28;
		labelContainer_8.add(dailiesLabel_m_8);

		// overlay_3
		const overlay_3 = scene.add.container(-4, 4);
		overlay_3.visible = false;
		rightOverlays.add(overlay_3);

		// dailiesOverlay_2
		const dailiesOverlay_2 = scene.add.image(-348, 28, "shop-reveal_32");
		dailiesOverlay_2.scaleX = 2;
		dailiesOverlay_2.scaleY = 2;
		dailiesOverlay_2.setOrigin(0.5, 0);
		overlay_3.add(dailiesOverlay_2);

		// guidanceArrow_2
		const guidanceArrow_2 = scene.add.image(-348, 128, "GuidanceArrow-Small");
		guidanceArrow_2.scaleX = 4;
		guidanceArrow_2.scaleY = 4;
		overlay_3.add(guidanceArrow_2);

		// labelContainer_9
		const labelContainer_9 = scene.add.container(-348, 156);
		overlay_3.add(labelContainer_9);

		// textBacking_9
		const textBacking_9 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 28, 0, 3, 3, 0, 0);
		textBacking_9.scaleX = 4;
		textBacking_9.scaleY = 32;
		textBacking_9.setOrigin(0.5, 0);
		textBacking_9.alpha = 0.5;
		textBacking_9.tint = 3023407;
		labelContainer_9.add(textBacking_9);

		// dailiesLabel_m_9
		const dailiesLabel_m_9 = scene.add.bitmapText(0, 0, "Aronui", "Shop");
		dailiesLabel_m_9.setOrigin(0.5, 0);
		dailiesLabel_m_9.tintTopLeft = 15130076;
		dailiesLabel_m_9.tintTopRight = 15130076;
		dailiesLabel_m_9.tintBottomLeft = 15130076;
		dailiesLabel_m_9.tintBottomRight = 15130076;
		dailiesLabel_m_9.text = "Shop";
		dailiesLabel_m_9.fontSize = -28;
		labelContainer_9.add(dailiesLabel_m_9);

		// overlay_4
		const overlay_4 = scene.add.container(-4, 4);
		overlay_4.visible = false;
		rightOverlays.add(overlay_4);

		// dailiesOverlay_3
		const dailiesOverlay_3 = scene.add.image(-420, 28, "inventory-reveal_32");
		dailiesOverlay_3.scaleX = 2;
		dailiesOverlay_3.scaleY = 2;
		dailiesOverlay_3.setOrigin(0.5, 0);
		overlay_4.add(dailiesOverlay_3);

		// guidanceArrow_3
		const guidanceArrow_3 = scene.add.image(-420, 128, "GuidanceArrow-Small");
		guidanceArrow_3.scaleX = 4;
		guidanceArrow_3.scaleY = 4;
		overlay_4.add(guidanceArrow_3);

		// labelContainer_10
		const labelContainer_10 = scene.add.container(-420, 156);
		overlay_4.add(labelContainer_10);

		// textBacking_10
		const textBacking_10 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 40, 0, 3, 3, 0, 0);
		textBacking_10.scaleX = 4;
		textBacking_10.scaleY = 32;
		textBacking_10.setOrigin(0.5, 0);
		textBacking_10.alpha = 0.5;
		textBacking_10.tint = 3023407;
		labelContainer_10.add(textBacking_10);

		// dailiesLabel_m_10
		const dailiesLabel_m_10 = scene.add.bitmapText(0, 0, "Aronui", "Backpack");
		dailiesLabel_m_10.setOrigin(0.5, 0);
		dailiesLabel_m_10.tintTopLeft = 15130076;
		dailiesLabel_m_10.tintTopRight = 15130076;
		dailiesLabel_m_10.tintBottomLeft = 15130076;
		dailiesLabel_m_10.tintBottomRight = 15130076;
		dailiesLabel_m_10.text = "Backpack";
		dailiesLabel_m_10.fontSize = -28;
		labelContainer_10.add(dailiesLabel_m_10);

		// overlay_5
		const overlay_5 = scene.add.container(-4, 4);
		overlay_5.visible = false;
		rightOverlays.add(overlay_5);

		// dailiesOverlay_4
		const dailiesOverlay_4 = scene.add.image(-492, 28, "settings-reveal");
		dailiesOverlay_4.scaleX = 4;
		dailiesOverlay_4.scaleY = 4;
		dailiesOverlay_4.setOrigin(0.5, 0);
		overlay_5.add(dailiesOverlay_4);

		// guidanceArrow_4
		const guidanceArrow_4 = scene.add.image(-492, 128, "GuidanceArrow-Small");
		guidanceArrow_4.scaleX = 4;
		guidanceArrow_4.scaleY = 4;
		overlay_5.add(guidanceArrow_4);

		// labelContainer_11
		const labelContainer_11 = scene.add.container(-492, 156);
		overlay_5.add(labelContainer_11);

		// textBacking_11
		const textBacking_11 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 40, 0, 3, 3, 0, 0);
		textBacking_11.scaleX = 4;
		textBacking_11.scaleY = 32;
		textBacking_11.setOrigin(0.5, 0);
		textBacking_11.alpha = 0.5;
		textBacking_11.tint = 3023407;
		labelContainer_11.add(textBacking_11);

		// dailiesLabel_m_11
		const dailiesLabel_m_11 = scene.add.bitmapText(0, 0, "Aronui", "Settings");
		dailiesLabel_m_11.setOrigin(0.5, 0);
		dailiesLabel_m_11.tintTopLeft = 15130076;
		dailiesLabel_m_11.tintTopRight = 15130076;
		dailiesLabel_m_11.tintBottomLeft = 15130076;
		dailiesLabel_m_11.tintBottomRight = 15130076;
		dailiesLabel_m_11.text = "Settings";
		dailiesLabel_m_11.fontSize = -28;
		labelContainer_11.add(dailiesLabel_m_11);

		// leftOverlays
		const leftOverlays = scene.add.container(0, 0);
		overlayContainer.add(leftOverlays);

		// overlay_6
		const overlay_6 = scene.add.container(32, 0);
		leftOverlays.add(overlay_6);

		// dailiesOverlay_5
		const dailiesOverlay_5 = scene.add.image(48, 32, "find-minigames-reveal_32");
		dailiesOverlay_5.scaleX = 2;
		dailiesOverlay_5.scaleY = 2;
		dailiesOverlay_5.setOrigin(0.5, 0);
		overlay_6.add(dailiesOverlay_5);

		// guidanceArrow_5
		const guidanceArrow_5 = scene.add.image(48, 132, "GuidanceArrow-Small");
		guidanceArrow_5.scaleX = 4;
		guidanceArrow_5.scaleY = 4;
		overlay_6.add(guidanceArrow_5);

		// labelContainer_12
		const labelContainer_12 = scene.add.container(84, 160);
		overlay_6.add(labelContainer_12);

		// textBacking_12
		const textBacking_12 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 64, 0, 3, 3, 0, 0);
		textBacking_12.scaleX = 4;
		textBacking_12.scaleY = 32;
		textBacking_12.setOrigin(0.5, 0);
		textBacking_12.alpha = 0.5;
		textBacking_12.tint = 3023407;
		labelContainer_12.add(textBacking_12);

		// dailiesLabel_m_12
		const dailiesLabel_m_12 = scene.add.bitmapText(0, 0, "Aronui", "Find Minigames");
		dailiesLabel_m_12.setOrigin(0.5, 0);
		dailiesLabel_m_12.tintTopLeft = 15130076;
		dailiesLabel_m_12.tintTopRight = 15130076;
		dailiesLabel_m_12.tintBottomLeft = 15130076;
		dailiesLabel_m_12.tintBottomRight = 15130076;
		dailiesLabel_m_12.text = "Find Minigames";
		dailiesLabel_m_12.fontSize = -28;
		labelContainer_12.add(dailiesLabel_m_12);

		// bottomOverlays
		const bottomOverlays = scene.add.container(512, 768);
		overlayContainer.add(bottomOverlays);

		// overlay_7
		const overlay_7 = scene.add.container(0, 0);
		bottomOverlays.add(overlay_7);

		// backing
		const backing = scene.add.nineslice(-32, -152, "Hud1", undefined, 144, 64, 8, 8, 8, 8);
		backing.scaleX = 4;
		backing.scaleY = 4;
		overlay_7.add(backing);

		// acceptButton
		const acceptButton = new DefaultButton(scene, -136, -72);
		acceptButton.scaleX = 1;
		acceptButton.scaleY = 1;
		overlay_7.add(acceptButton);

		// duelButton
		const duelButton = scene.add.image(200, -224, "duel2");
		duelButton.scaleX = 4;
		duelButton.scaleY = 4;
		overlay_7.add(duelButton);

		// dialogueText
		const dialogueText = scene.add.bitmapText(-232, -176, "Aronui", "Let's match letters to their sounds in Mystic Match!");
		dialogueText.tintTopLeft = 5387071;
		dialogueText.tintTopRight = 5387071;
		dialogueText.tintBottomLeft = 5387071;
		dialogueText.tintBottomRight = 5387071;
		dialogueText.text = "Let's match letters to their sounds in Mystic Match!";
		dialogueText.fontSize = -24;
		dialogueText.maxWidth = 425;
		overlay_7.add(dialogueText);

		// cancelButton
		const cancelButton = new DefaultDenyButton(scene, 80, -72);
		overlay_7.add(cancelButton);

		// tint
		const tint = scene.add.image(-320, -280, "1x1sprite");
		tint.scaleX = 576;
		tint.scaleY = 256;
		tint.setOrigin(0, 0);
		tint.alpha = 0.3;
		tint.alphaTopLeft = 0.3;
		tint.alphaTopRight = 0.3;
		tint.alphaBottomLeft = 0.3;
		tint.alphaBottomRight = 0.3;
		tint.tintTopLeft = 0;
		tint.tintTopRight = 0;
		tint.tintBottomLeft = 0;
		tint.tintBottomRight = 0;
		overlay_7.add(tint);

		// dailiesOverlay_6
		const dailiesOverlay_6 = scene.add.image(200, -256, "duel-reveal");
		dailiesOverlay_6.scaleX = 4;
		dailiesOverlay_6.scaleY = 4;
		dailiesOverlay_6.setOrigin(0.5, 0);
		overlay_7.add(dailiesOverlay_6);

		// guidanceArrow_6
		const guidanceArrow_6 = scene.add.image(200, -296, "GuidanceArrow-Small");
		guidanceArrow_6.scaleX = 4;
		guidanceArrow_6.scaleY = 4;
		guidanceArrow_6.flipY = true;
		overlay_7.add(guidanceArrow_6);

		// labelContainer_13
		const labelContainer_13 = scene.add.container(200, -368);
		overlay_7.add(labelContainer_13);

		// textBacking_13
		const textBacking_13 = scene.add.nineslice(0, 2, "fadeOut2", undefined, 50, 0, 3, 3, 0, 0);
		textBacking_13.scaleX = 4;
		textBacking_13.scaleY = 32;
		textBacking_13.setOrigin(0.5, 0);
		textBacking_13.alpha = 0.5;
		textBacking_13.tint = 3023407;
		labelContainer_13.add(textBacking_13);

		// dailiesLabel_m_13
		const dailiesLabel_m_13 = scene.add.bitmapText(0, 0, "Aronui", "Start Duel");
		dailiesLabel_m_13.setOrigin(0.5, 0);
		dailiesLabel_m_13.tintTopLeft = 15130076;
		dailiesLabel_m_13.tintTopRight = 15130076;
		dailiesLabel_m_13.tintBottomLeft = 15130076;
		dailiesLabel_m_13.tintBottomRight = 15130076;
		dailiesLabel_m_13.text = "Start Duel";
		dailiesLabel_m_13.fontSize = -28;
		labelContainer_13.add(dailiesLabel_m_13);

		// interactiveOverlay
		const interactiveOverlay = scene.add.image(0, 0, "1x1sprite");
		interactiveOverlay.setInteractive(new Phaser.Geom.Rectangle(0, 0, 1, 1), Phaser.Geom.Rectangle.Contains);
		interactiveOverlay.scaleX = 1024;
		interactiveOverlay.scaleY = 768;
		interactiveOverlay.setOrigin(0, 0);
		interactiveOverlay.alpha = 0.0001;
		interactiveOverlay.alphaTopLeft = 0.0001;
		interactiveOverlay.alphaTopRight = 0.0001;
		interactiveOverlay.alphaBottomLeft = 0.0001;
		interactiveOverlay.alphaBottomRight = 0.0001;
		desktopView.add(interactiveOverlay);

		// continueButtonContainer
		const continueButtonContainer = scene.add.container(1024, 768);
		desktopView.add(continueButtonContainer);

		// continueButton
		const continueButton = new DefaultButton(scene, -120, -48);
		continueButtonContainer.add(continueButton);

		// loadingContainer
		const loadingContainer = new LoadingContainer(scene, 0, 0);
		this.add(loadingContainer);

		// acceptButton_m (prefab fields)
		acceptButton_m.buttonText = "Yes";

		// cancelButton_m (prefab fields)
		cancelButton_m.buttonText = "No";

		// continueButton_m (prefab fields)
		continueButton_m.buttonText = "Next";

		// acceptButton (prefab fields)
		acceptButton.buttonText = "Yes";

		// cancelButton (prefab fields)
		cancelButton.buttonText = "No";

		// continueButton (prefab fields)
		continueButton.buttonText = "Next";

		this.greenleaf_m = greenleaf_m;
		this.overlay_intro_m = overlay_intro_m;
		this.overlay_1_m = overlay_1_m;
		this.overlay_2_m = overlay_2_m;
		this.overlay_3_m = overlay_3_m;
		this.overlay_4_m = overlay_4_m;
		this.overlay_5_m = overlay_5_m;
		this.overlay_6_m = overlay_6_m;
		this.rightOverlays_m = rightOverlays_m;
		this.leftOverlays_m = leftOverlays_m;
		this.dialogueText_m = dialogueText_m;
		this.cancelButton_m = cancelButton_m;
		this.overlay_7_m = overlay_7_m;
		this.bottomOverlays_m = bottomOverlays_m;
		this.interactiveOverlay_m = interactiveOverlay_m;
		this.continueButton_m = continueButton_m;
		this.continueButtonContainer_m = continueButtonContainer_m;
		this.mobileView = mobileView;
		this.greenleaf = greenleaf;
		this.overlay_intro = overlay_intro;
		this.overlay_1 = overlay_1;
		this.overlay_2 = overlay_2;
		this.overlay_3 = overlay_3;
		this.overlay_4 = overlay_4;
		this.overlay_5 = overlay_5;
		this.rightOverlays = rightOverlays;
		this.overlay_6 = overlay_6;
		this.leftOverlays = leftOverlays;
		this.dialogueText = dialogueText;
		this.cancelButton = cancelButton;
		this.overlay_7 = overlay_7;
		this.bottomOverlays = bottomOverlays;
		this.interactiveOverlay = interactiveOverlay;
		this.continueButton = continueButton;
		this.continueButtonContainer = continueButtonContainer;
		this.desktopView = desktopView;
		this.loadingContainer = loadingContainer;

		/* START-USER-CTR-CODE */
    this.init();
    /* END-USER-CTR-CODE */
	}

	private greenleaf_m: Phaser.GameObjects.Image;
	private overlay_intro_m: Phaser.GameObjects.Container;
	private overlay_1_m: Phaser.GameObjects.Container;
	private overlay_2_m: Phaser.GameObjects.Container;
	private overlay_3_m: Phaser.GameObjects.Container;
	private overlay_4_m: Phaser.GameObjects.Container;
	private overlay_5_m: Phaser.GameObjects.Container;
	private overlay_6_m: Phaser.GameObjects.Container;
	private rightOverlays_m: Phaser.GameObjects.Container;
	private leftOverlays_m: Phaser.GameObjects.Container;
	public dialogueText_m: Phaser.GameObjects.BitmapText;
	public cancelButton_m: DefaultDenyButton;
	private overlay_7_m: Phaser.GameObjects.Container;
	private bottomOverlays_m: Phaser.GameObjects.Container;
	public interactiveOverlay_m: Phaser.GameObjects.Image;
	public continueButton_m: DefaultConfirmButton_m;
	private continueButtonContainer_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;
	private greenleaf: Phaser.GameObjects.Image;
	private overlay_intro: Phaser.GameObjects.Container;
	private overlay_1: Phaser.GameObjects.Container;
	private overlay_2: Phaser.GameObjects.Container;
	private overlay_3: Phaser.GameObjects.Container;
	private overlay_4: Phaser.GameObjects.Container;
	private overlay_5: Phaser.GameObjects.Container;
	private rightOverlays: Phaser.GameObjects.Container;
	private overlay_6: Phaser.GameObjects.Container;
	private leftOverlays: Phaser.GameObjects.Container;
	public dialogueText: Phaser.GameObjects.BitmapText;
	public cancelButton: DefaultDenyButton;
	private overlay_7: Phaser.GameObjects.Container;
	private bottomOverlays: Phaser.GameObjects.Container;
	public interactiveOverlay: Phaser.GameObjects.Image;
	public continueButton: DefaultButton;
	private continueButtonContainer: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;
	private loadingContainer: LoadingContainer;

	/* START-USER-CODE */

  walkthroughController?: WalkthroughController;
  isLoadingAudio = false;

  init() {
    const numSlides = 7;
    // Intro.
    this.scene.load.audio(
      `hud-walkthrough-intro`,
      `game_assets/audio/mentors/walkthroughs/walkthrough-hud-intro.mp3`,
    );
    // Steps.
    for (var i = 0; i < numSlides; i++) {
      this.scene.load.audio(
        `hud-walkthrough-${i}`,
        `game_assets/audio/mentors/walkthroughs/walkthrough-hud-${i}.mp3`,
      );
    }
    this.scene.load.start();
    this.isLoadingAudio = true;
    this.setVisible(true);

    const audioKeys = [];
    audioKeys.push('hud-walkthrough-intro');
    for (let i = 0; i < numSlides; i++) {
      audioKeys.push(`hud-walkthrough-${i}`);
    }
    const slides = [
      this.overlay_intro,
      this.overlay_1,
      this.overlay_2,
      this.overlay_3,
      this.overlay_4,
      this.overlay_5,
      this.overlay_6,
      this.overlay_7,
    ];

    const slides_m = [
      this.overlay_intro_m,
      this.overlay_1_m,
      this.overlay_2_m,
      this.overlay_3_m,
      this.overlay_4_m,
      this.overlay_5_m,
      this.overlay_6_m,
      this.overlay_7_m,
    ];

    this.walkthroughController = new WalkthroughController({
      audioKeys: audioKeys,
      parent: this,
      slides,
      slides_m,
      continueButton: this.continueButton,
      continueButton_m: this.continueButton_m,
      responsiveOverlay: this.interactiveOverlay,
      responsiveOverlay_m: this.interactiveOverlay_m,
    });

    this.scene.load.on('complete', async () => {
      // Finished loading the audio files for the walkthrough.
      this.loadingContainer.setVisible(false);
      this.isLoadingAudio = false;
    });

    this.initializeResponsiveness();
  }

  async start() {
    await waitUntil(this.scene.time, () => !this.isLoadingAudio);
    this.walkthroughController?.initialize();
  }

  async reset() {
    await waitUntil(this.scene.time, () => !this.isLoadingAudio);
    this.walkthroughController?.reset();
  }

  getResponsiveElements(key: keyof WalkthroughPanel) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  // The panel itself handles the responsiveness rather than the controller.
  // This is because different panels have different layouts and the controller
  // is only in charge of logic.
  initializeResponsiveness() {
    // Responsiveness.
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });

    const anchor = getAnchorPlugin(this.scene);
    anchor.add(this, {
      left: '0%',
      top: '0%',
    });

    // Desktop responsiveness.
    anchor.add(this.interactiveOverlay, {
      width: '100%',
      height: '100%',
    });
    anchor.add(this.leftOverlays, {
      left: '0%',
    });
    anchor.add(this.rightOverlays, {
      right: '100%',
    });
    anchor.add(this.greenleaf, {
      right: '90%',
      bottom: '100%+100',
    });
    anchor.add(this.continueButtonContainer, {
      right: '100%',
      bottom: '100%',
    });
    anchor.add(this.bottomOverlays, {
      bottom: '100%',
      centerX: '50%',
    });
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.leftOverlays);
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.rightOverlays);
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.bottomOverlays);
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.continueButtonContainer,
    );

    // Mobile Responsiveness.
    anchor.add(this.interactiveOverlay_m, {
      width: '100%',
      height: '100%',
    });
    anchor.add(this.leftOverlays_m, {
      left: '0%',
    });
    anchor.add(this.rightOverlays_m, {
      right: '100%',
    });
    anchor.add(this.greenleaf_m, {
      left: '5%',
      bottom: '100%+320',
    });
    anchor.add(this.continueButtonContainer_m, {
      right: '100%',
      bottom: '100%',
    });
    anchor.add(this.bottomOverlays_m, {
      bottom: '100%',
      centerX: '50%',
    });
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.leftOverlays_m,
      { scaleModifier: 0.5 },
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.rightOverlays_m,
      { scaleModifier: 0.5 },
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.bottomOverlays_m,
      { scaleModifier: 0.5 },
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.continueButtonContainer_m,
      { scaleModifier: 0.75 },
    );
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
